import React from 'react';
import { Star, MessageSquareQuote, CheckCircle2 } from 'lucide-react';
export function Reviews() {
  const reviews = [{
    quote: '[Paste real customer review here.]',
    name: '[Customer Name]',
    city: '[City]',
    label: 'Shower Glass Customer'
  }, {
    quote: '[Paste real customer review here.]',
    name: '[Customer Name]',
    city: '[City]',
    label: 'Homeowner'
  }, {
    quote: '[Paste real customer review here.]',
    name: '[Customer Name]',
    city: '[City]',
    label: 'Bathroom Remodel'
  }];
  const proofItems = ['Free In-Home Quotes', 'Custom Measured', '18 Glass Designs & Textures', 'Lifetime Installation Guarantee', 'Family-Owned Since 2000'];
  return <section className="py-20 bg-white" aria-labelledby="reviews-heading" data-id="element-1677">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-1678">
        <div className="text-center max-w-3xl mx-auto mb-14 anim-on-scroll" data-id="element-1679">
          <div className="inline-flex items-center gap-2 mb-4 bg-amber-50 border border-amber-100 px-3 py-1.5 rounded-full" aria-label="5-star rated" data-id="element-1680">
            <span className="flex" aria-hidden="true" data-id="element-1681">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-1682" />)}
            </span>
            <span className="text-xs font-semibold text-amber-900 uppercase tracking-wider" data-id="element-1683">
              5-Star Rated
            </span>
          </div>
          <h2 id="reviews-heading" className="text-3xl md:text-4xl font-bold text-navy mb-5 tracking-tight" data-id="element-1684">
            What Customers Say About Kosin's Glass
          </h2>
          <p className="text-lg text-gray-600" data-id="element-1685">
            Homeowners, remodelers and builders count on Kosin's Glass for
            custom shower glass, frameless enclosures, quality hardware and
            professional installation.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-6 mb-14" data-id="element-1686">
          {reviews.map((review, i) => <article key={i} className="bg-gray-50 rounded-2xl p-7 border border-gray-100 shadow-sm hover:shadow-soft transition-shadow flex flex-col h-full scroll-fade-up" style={{
          animationDelay: `${i * 0.1}s`
        }} data-id="element-1687">
              <MessageSquareQuote className="w-7 h-7 text-primary/30 mb-4" aria-hidden="true" data-id="element-1688" />
              <div className="flex items-center gap-1 mb-3" aria-label="5-star review" data-id="element-1689">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-1690" />)}
              </div>
              <blockquote className="text-gray-700 italic leading-relaxed mb-6 flex-1" data-id="element-1691">
                "{review.quote}"
              </blockquote>
              <footer className="border-t border-gray-200 pt-4 not-italic" data-id="element-1692">
                <p className="font-semibold text-navy text-sm" data-id="element-1693">{review.name}</p>
                <p className="text-xs text-gray-500 mt-0.5" data-id="element-1694">
                  {review.city} · {review.label}
                </p>
              </footer>
            </article>)}
        </div>
        <div className="anim-on-scroll" data-id="element-1695">
          <div className="bg-glass rounded-2xl p-5 md:p-6 border border-gray-100" data-id="element-1696">
            <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3" data-id="element-1697">
              {proofItems.map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-1698">
                  <CheckCircle2 className="w-4 h-4 text-primary shrink-0" aria-hidden="true" data-id="element-1699" />
                  <span className="text-sm font-medium text-navy whitespace-nowrap" data-id="element-1700">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}